import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sjan-award',
  templateUrl: './sjan-award.component.html',
  styleUrls: ['./sjan-award.component.scss']
})
export class SjanAwardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
